import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SelectLanguage from '../../common/SelectLanguage/SelectLanguage';

const supportedLanguages = [
  { value: 'en' },
  { value: 'ee' },
];

function LanguagePicker() {
  const { i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('lang') || 'en');

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('lang', lang);
    setSelectedLanguage(lang);
  };

  return (
    <SelectLanguage
      options={supportedLanguages}
      value={selectedLanguage}
      onUpdate={changeLanguage}
    />
  );
}

export default LanguagePicker;
